export default {
  selectType: '賬戶類別',
  applys: '申請',
  accountNum: '賬號 : ',
  applyRecords: '申請記錄',
  noRecords: '暫無交易賬戶申請記錄',
  orderId: '訂單編號:',
  accountType: '賬戶類型',
  status: '狀態',
  submitted: '審核中',
  checking: '審核中',
  pass: '審核中',
  reject: '審核失敗',
  success: '已開通',
  nonactivated: '去開通',
  toapply: '申請開通',
  reapply: '重新申請',
  SUCCESS: '已開通',
  OPEN: '已開通',
  CLOSE: '已關閉',
  STOP: '已停止',
  REJECT: '申請失敗',
  CHECKING: '審核中',
  PASS: '審核中',
  SUBMITTED: '已提交',
  TOSTOP: '去停用',

  refuseReason: '備註',
  apply: '賬號申請',
  uploadAddress: '請上傳住址證明',
  uploadId: '請上傳身份證明',
  IdCardFace: '請上傳身份證人像面',
  IdCardNational: '請上傳身份證國徽面',
  picTypeErr: '僅接受JPG，PNG，PDF，JPEG格式',
  picSizeErr: '上傳文件不能超過5M',
  addressTips: {
    tips: '溫馨提示',
    line1: '1、拍照時請將證明文件平放，保持光照充足並避免反光；',
    line2:
      '2、請確保證明文件上的姓名、日期、住址等信息清晰可見，確保證明文件在最近三個月內；',
    line3:
      '3、證明文件可以是水電煤、電信、寬帶等的增值稅發票；或者經執業會計師、律師或公證人認證的信用卡對賬單、水電、煤氣、電信通知單等；',
    line4:
      '4、如您的住址與身分證上的相同，請再次上傳身分證人像面作為住址證明。 ',
    upload_image_verify_isNull: '請上傳住址證明',
    upload_image_verify_size: '上傳圖片不能超過5M',
    upload_image_verify_type: '僅接受JPG，PNG，PDF，JPEG格式'
  },
  idTips: {
    tips: '溫馨提示：',
    line1: '1、拍照時請將證件平放；',
    line2: '2、請確保身份證邊框完整、文字清晰可見；',
    line3: '3、照片上傳後，若不滿意可點擊照片重拍。 ',
    upload_image_verify_isNull: '請上傳身份證明',
    upload_image_verify_size: '上傳圖片不能超過5M',
    upload_image_verify_type: '僅接受JPG，PNG，PDF，JPEG格式'
  },
  infomationTips: {
    read: '請詳細閱讀以下內容',
    haveRead: '本人已閱讀',
    rules: '「艾德證券期貨有限公司業務條款及細則」。 ',
    rulesLink:
      'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Business-Terms-and-Conditions.pdf',
    statement: '「風險披露聲明」。 ',
    statementLink:
      'http://download.eddidapp.com/pdf/TC/Risk-Disclosure-Statement.pdf',
    textOne: '本人同意並確認，本人已根據',
    linkOneText: '「業務條款及細則」',
    linkOne:
      'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Business-Terms-and-Conditions.pdf',
    textTwo: '中第十一章',
    linkTwoText: '「常設授權書」',
    linkTwo:
      'https://middleware-agreement-prod-public.oss-cn-shenzhen.aliyuncs.com/2021-07/ba408037-4028-4217-9c1d-df5d2aa24384',
    lastText:
      '內之條款及細則授權及/或指示貴公司處置本人之證券、證券抵押品和款項，並且本人已詳細閱讀及明白該條款的內容。'
  },
  checkedConfirm: '本人確認本人之所有資料與開戶時所提交的資料相同',
  checked: '請勾選',
  confirm: '確認申請',
  reSubmit: '修改並重新提交',
  errTips: {
    upload_address_verify_isNull: '請上傳地址證明',
    upload_id_verify_isNull: '請上傳身份證明',
    upload_image_verify_size: '上傳圖片不能超過5M',
    upload_image_verify_type: '僅接受JPG，PNG，PDF，JPEG格式',
    comfirmInfoError: '如您有資料更改，請聯絡客戶服務',
    pleaseComfirmInfo: '請確認資料是否相同',
    pleaseReadText: '如已閱讀，請勾選',
    pleaseSelectInvestmentExperience: '請選擇您的外匯投資經驗',
    pleaseSelectPurposeOfInvestment: '至少選擇一項投資目標',
    purposeOfInvestmentTips:
      '買賣槓桿式外匯並不適合投資目標僅為「利息/股息收入」人士',
    riskToleranceTips:
      '槓桿式外匯交易為高風險產品，並不適合風險承受能力為「中」或「低」人士'
  },
  buttonText: {
    nonactivated: '去開通',
    success: '已開通',
    submitted: '審核中',
    checking: '審核中',
    pass: '審核中',
    reject: '申請失敗'
  },
  confirmText: '本人確認本人之資料並無改變，與開戶時所提交的資料相同。 ',
  applyFDTMTandC: `<span style="font-weight: 700">客戶申請艾德證券期貨有限公司(「艾德證券期貨」)之期貨日內交易賬戶服務前，請細閱本額外風險警告及條款（「本聲明」）。</span> </br></br>
  <span style="font-weight: 700">期貨日內交易賬戶之額外風險警告</span></br>
  此簡要之風險警告聲明並不能盡述有關期貨日內交易賬戶之所有風險及其他重要事項。鑒於只針對向專業投資者及特選客戶開放之少於最低按金要求建立新期貨倉盤會有極高風險，閣下務須首先了解閣下將會訂立之合約之特性(及其契約關係)以及閣下所能承擔之風險程度，方能進行此種交易。此類少於最低按金要求建立新期貨倉盤交易只適合少量專業投資者及特選客戶。閣下應在仔細權衡本身之經驗、目標、財政來源及其他有關情況後，方判斷閣下是否適合進行此類期貨保證金交易。</br></br>
  <span style="font-weight: 700">一般期貨及期權交易的風險</span></br>
  買賣期貨合約或期權的虧蝕風險可以極大。在若干情況下，閣下所蒙受的虧蝕可能會超過最初存入的保證金數額。即使閣下設定了備用指示，例如「止損」或「限價」等指示，亦未必能夠避免損失。市場情況可能使該等指示無法執行。閣下可能會在短時間內被要求存入額外的保證金。假如未能在指定的時間內提供所需款項，閣下的未平倉合約可能會被平倉。然而，閣下仍然要對閣下的賬戶內任何因此而出現的欠款負責。因此，閣下在買賣前應研究及理解期貨合約及期權，以及根據本身的財政狀況及投資目標，仔細考慮這種買賣是否適合閣下。如果閣下買賣期權，便應熟悉行使期權及期權到期時的程序，以及閣下在行使期權及期權到期時的權利與責任。</br></br>
  <span style="font-weight: 700">針對以少於最低按金要求建立新期貨倉盤交易的風險</span></br>
  此類以少於最低按金要求建立新期貨倉盤交易的風險極高。由於此類交易的開倉保證金要求的金額較正常期貨交易合約本身的開倉保證金要求相對只有三分之一，因而在此類交易中發揮極高「槓桿」作用。市場輕微的波動也會對閣下投入或將需要投入的資金造成極大比例的影響。對閣下來說，這種槓桿作用可說是弊多於利。因此閣下可能會損失全部開倉保證金及為維持本身的倉盤而向有關商號存入的額外金額。如果市況不利閣下所持倉盤或保證金水平提高，閣下會遭追收保證金，須在短時間內存入額外資金以維持本身倉盤。假如閣下未有在指定時間內繳付額外的資金，或市場上期貨合約價格進一步波動令保證金水平進一步降低至爆倉水平時，閣下可能會被迫在虧蝕情況下平倉，而所有因此出現的短欠數額一概由閣下承擔。 例子：假設爆倉風險率為80%，於付足夠開倉保證金要求下，期貨保證金交易市況不利於你反向波動大概下跌600點，客戶之交易合約將被強制平倉；但當客戶以少於最低按金要求建立新倉，期貨保證金交易市況不利於你反向波動大概只需下跌200點<span style="font-weight: 700">（市況波動比正常付足夠開倉保證金少大概三分之一情況下）</span>，客戶之交易合約便會強制平倉。</br></br>
  <span style="font-weight: 700">減低風險交易指示或投資策略</span></br>
  即使閣下採用某些旨在預設虧損限額的交易指示(如「止損」或「止損限價」指示)，也有可能起不了任何作用，因為在極高槓桿比率及市況波動情況下，這些交易指示基本上無法執行。</br></br>
  <span style="font-weight: 700">針對申請成為專業投資者的客戶之警告</span></br>
  專業投資者更多的是指具有一定交易經驗和專業知識的個人交易者或機構。「專業投資者」的定義載於《證券及期貨條例》附表1第1部第1條，「個人專業投資者」定義為根據《專業投資者規則》第5(1)及5(2)條所指的個人；「法團專業投資者」定義為根據《專業投資者規則》第6(a)、6(b)及6(c)條所指的法團。閣下應仔細衡量自身之條件是否附合專業投資者之要求，及這種極高風險買賣是否適合閣下。一旦閣下確認成為專業投資者並進行此類以少於最低按金要求建立新期貨倉盤交易，閣下所面對極高之虧損風險是一般投資者無法承受的。艾德證券期貨不會就閣下之虧損負上任何責任。敬請閣下在申請前三思。 </br></br>
  <span style="font-weight: 700">期貨日內交易賬戶之額外條款</span></br>
  此「額外條款」為附帶於艾德證券期貨有限公司之業務條款及細則，進行以少於最低按金要求建立新期貨倉盤交易的客戶除受業務條款及細則約束外，同時需受此額外條款約束。閣下務須首先了解此額外條款，方能進行此種交易。</br></br>
  1 開立「期貨日內交易賬戶」額外要求:</br>
    &nbsp;1.1 於艾德證券期貨成功開立期貨賬戶(保證金)至少滿3個月；</br>
    &nbsp;1.2 在最近至少一年客戶之期貨交易賬戶內沒有任何下列一種情況出現： </br>
    &nbsp;&nbsp;&nbsp;1.2.1 未能履行保證金的紀錄；或</br>
    &nbsp;&nbsp;&nbsp;1.2.2 遭強制平倉紀錄；或</br>
    &nbsp;&nbsp;&nbsp;1.2.3 遭退票紀錄；</br>
    &nbsp;1.3 在最近一個月內有最少一次買賣期貨持倉過夜的交易紀錄；及</br>
    &nbsp;1.4 維持平穩健財務狀況。</br>
    &nbsp;1.5 艾德證券期貨保留最終全權酌情決定權。</br></br>
  2 「期貨日內交易賬戶」申請及交易條款</br>
  &nbsp;2.1 客戶知悉艾德證券期貨會將客戶於現有期貨交易賬戶內的所有資金，全數轉賬至新開立的期貨日內交易賬戶內；</br>
  &nbsp;2.2 期貨日內交易賬戶只提供香港交易所、美國芝加哥商品交易所及新加坡交易所之特定期貨產品；</br>
  &nbsp;2.3 每日強制平倉</br>
  &nbsp;&nbsp;&nbsp;2.3.1 期貨日內交易賬戶內所有持倉將不能隔夜，所有開倉必需即日平倉。如客戶於指定強制平倉時間前未有自行把所有開倉平倉，艾德證券期貨將會把所有倉位於下列指定強制平倉時間強制平掉，<span style="font-weight: 700">且不作任何額外通知</span></br>
  香港交易所每日強制平倉時間 (香港時間) : 3:30pm</br>
  美國芝加哥商品交易所每日強制平倉時間 (香港時間) : 3:00am</br>
  新加坡交易所每日強制平倉時間 (香港時間) : 3:00pm</br>
  &nbsp;2.4 任何時候若期貨日內交易賬戶內持倉風險率一旦低於百份之八十 (80%)，艾德證券期貨將會執行強制平倉，直至持倉風險率提高至百份之一百(100%)或以上；</br>
  &nbsp;2.5 艾德證券期貨擁有就強制平倉最終全權酌情決定權。</br>
  &nbsp;2.6 若客戶申請取消期貨日內交易賬戶服務後，30曆日內不可再申請該服務。</br></br>
  3 取消「期貨日內交易賬戶」資格</br>
  &nbsp;3.1 若下列任何一種情況出現於客戶之期貨日內交易賬戶內，其期貨日內交易賬戶之資格將<span style="font-weight: 700">被立即被取消</span>：</br>
  &nbsp;&nbsp;&nbsp;3.1.1 客戶未能於指定時間內履行艾德證券期貨發出的追加保證金要求；</br>
  &nbsp;&nbsp;&nbsp;3.1.2 客戶的持倉因賬戶內持倉風險率低於百份之八十 (80%)，而遭艾德證券期貨執行強制平倉；或</br>
  &nbsp;&nbsp;&nbsp;3.1.3 客戶存入的個人支票遭退票，未能清算。</br>
        &nbsp;3.2 個別被取消資格的客戶若希望重新申請成為期貨日內交易賬戶客戶，該客戶必須在最近至少一年內沒有任何未能履行保證金責任的記錄。</br>
        &nbsp;3.3 若出現任何事件，並導致艾德證券期貨有理由懷疑客戶未能證明其有貫徹履行保證金責任及/或能維持穩健的財務狀況，艾德證券期貨將立即重新評估該客戶是否仍符合作為期貨日內交易賬戶客戶的資格。</br></br>
  4 艾德證券期貨將會定時檢視期貨日內交易賬戶客戶資格，確保客戶符合期貨日內交易賬戶額外要求。並就「期貨日內交易賬戶」額外條款擁有最終全權酌情決定權。</br></br>`,
  requestError: {
    EXIT_APPROVAL_RECORD: '存在正在审核的记录，不能重复提交'
  },
  tipsText1: '如有其他資料更改，請聯繫客戶服務:',
  tipsText2:
    '+852 2655 0338 / 400 120 0068（中國內地免費熱線） | 電郵：cs@eddidsec.com',
  fdtmAgreeText: {
    text1:
      '本人已閱讀及明白艾德證券期貨之「期貨日內交易賬戶額外風險警告及條款」，並同意受其所約束',
    text2:
      '本人同意將本人于現有期貨交易賬戶內的所有資金全數轉賬至日內交易賬戶內',
    text3:
      '「期貨日內交易賬戶」只適用于合資格客戶，艾德證券期貨擁有最終全權酌情決定權。 '
  },
  mt5ApplyForm: {
    tipsTitle:
      '本人現申請開立<strong class="font_blod">「槓桿式外匯賬戶(保證金)交易賬戶」</strong>',
    recomfireText: '請重新確認以下個人信息',
    investmentExperienceText: '外匯投資經驗是:',
    investmentExperienceOps: {
      a: '少於一年',
      b: '一至五年',
      c: '六至十年',
      d: '多於十年'
    },
    investmentObjectiveText: '投資目標是（選擇所有適用）:',
    investmentObjectiveOps: {
      a: '投機',
      b: '對沖',
      c: '資產增值',
      d: '利息/股息收入'
    },
    riskToleranceText: '風險承受能力是:',
    riskToleranceTextOps: {
      a: '高',
      b: '中',
      c: '低'
    },
    confirmInformationText:
      '本人確認本人其他資料並無改變，與開戶時所提交的資料相同。',
    confirmInformationTips:
      '如有其他資料更改，請聯絡客戶服務: +852 2655 0338 / 400 120 0068（中國內地免費熱線）｜電郵：<a href="mailto:cs@eddidsec.com">cs@eddidsec.com</a>',
    riskStatement: {
      header: '本人確認本人已完全細閲、明白及確認本',
      rules: ' 「程式交易風險聲明」',
      rulesLink:
        'http://download.eddidapp.com/pdf/TC/program-trading-risk-statement.pdf'
    },
    riskStatementFoot:
      '如欲停止「程式交易」功能，請聯絡客戶服務: +852 2655 0338 / 400 120 0068（中國內地免費熱線）｜電郵：<a href="mailto:cs@eddidsec.com">cs@eddidsec.com</a>',
    articleContent: `
    <p><strong class="font_blod">本人，謹此向艾德證券期貨有限公司確認及聲明：</strong></p>
    <p>1.本人已閱讀及明白艾德證券期貨之
      <a class="font-16" href="https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Business-Terms-and-Conditions.pdf" target="_blank">
        <span class="statement">「業務條款及細則」</span></a>，並同意受其所約束；</p>
    <p>2.本人已閱讀及明白艾德證券期貨之
      <a class="font-16" href="https://download.eddidapp.com/pdf/TC/Risk-Disclosure-Statement.pdf" target="_blank">
        <span class="statement">「風險披露聲明」</span></a>及
      <a class="font-16" href="http://download.eddidapp.com/pdf/TC/order-execution-policy.pdf" target="_blank">
        <span class="statement">「訂單執行政策」</span></a>，並清楚了解杠杆式外汇交易屬高風險投資產品；</p>
    <p>3.本人已明白杠杆式外汇交易的虧損風險可以十分重大。本人所蒙受的虧損可能超過本人的最初保證金款額。本人將要為本人的賬戶所出現的任何逆差負責。</p>
    `
  },
  pleaseInput: '請輸入',
  aboutMargin: '相關保證金',
  aboutMarginTitle1:
    '本人及/或本人配偶未持有艾德證券期貨任何相關的保證金賬戶',
  aboutMarginTitle2:
    '本人及/或本人配偶沒有單獨或共同控制艾德證券期貨的其他保證金賬戶35%或以上的表決權',
  aboutMarginTitle3:
    '本人沒有以客戶的同一集團公司旗下的其他公司在艾德證券期貨開立保證金賬戶',
  aboutMarginAccountName: '賬戶持有人姓名',
  aboutMarginAccountNumber: '賬戶號碼',
  aboutMarginAccountNameErr: '請填寫賬戶持有人姓名',
  aboutMarginAccountNumberErr: '請填寫賬戶號碼',
  illegalMarginAccountNumber: '請填寫正確的賬戶號碼',
  oneInfo: '由於您：選擇開通期貨交易賬戶，必須勾選至少一項衍生品相關經驗',
  logOutQues: {
    title:
      '本人申請即日起停用本人「期貨日內交易賬戶」，謹向艾德證券期貨有限公司確認：',
    Q1: '本人同意於成功停用「期貨日內交易賬戶」後，30日內不可再申請此服務',
    Q2:
      '本人同意若賬戶停用後有任何結餘（正或負），所有結餘將全數轉賬至本人之期貨交易賬戶內。 '
  },
  agree: '您需要閱讀並勾選相關協議才能提交',
  fmdInfo: '期貨日內交易賬戶停用',
  companyName: '目前公司名稱：',
  employmentYears: '受僱年期：',
  employmentYearsError: '該數值不在可輸入範圍內',
  yearsError: '請輸入正整數',
  notZeroFirst: '整數不能以0開頭',
  hideYears: '直至目前為止，本人為退休/無業',
  employmentYearsEnter: '請輸入受僱年期',
  notAccount:
    '您無法開通當前交易帳戶，請致電 +852 2655 0338 / 400 120 0068（中國內地免費熱線） 或 電郵至 cs@eddidsec.com 與我們聯絡',
  complianceDeclarationTextOne: '本人確認已閱讀、理解並同意',
  declarationLink: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/ChineseMainlandInvestorComplianceDeclaration.pdf',
  declarationLinkContent: '《中國內地投資者合規聲明書》',
  declarationLastText: '的全部內容。'
}
